import { Link } from 'react-router-dom';
import { testimonials, faqs } from '@/mocks/comics';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import PageSEO from '@/components/feature/PageSEO';

export default function AboutPage() {
  const pageSchema = {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name: '关于韩漫网 - 免费韩漫大全',
    description: '韩漫网致力于为中文漫画爱好者提供免费韩国漫画，无删减下拉式阅读体验',
    url: 'http://stgoldcoast.com/about',
    isPartOf: {
      '@type': 'WebSite',
      name: '韩漫网',
      url: 'http://stgoldcoast.com/',
    },
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };

  return (
    <>
      <PageSEO
        title="关于韩漫网_免费韩漫大全品牌故事_联系我们"
        description="了解韩漫网的品牌故事与口碑。韩漫网致力于为广大漫画爱好者提供免费韩国漫画、无删减下拉式在线阅读服务，随时随地享受漫画乐趣。"
        keywords="韩漫网,关于韩漫网,免费韩漫,韩国漫画平台,联系我们"
        canonicalUrl="/about"
        schemaJson={{ ...pageSchema, ...faqSchema }}
      />

      <Navbar />

      <main>
        {/* Hero */}
        <section className="relative w-full h-[380px] md:h-[480px] flex flex-col items-center justify-center overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=A%20wide%20artistic%20Korean%20manhwa%20style%20illustration%20showing%20creative%20studio%20with%20drawing%20tablets%20and%20comic%20pages%20scattered%2C%20warm%20golden%20and%20coral%20tones%2C%20inspirational%20atmosphere%2C%20clean%20modern%20composition%2C%20soft%20gradient%20background%2C%20digital%20art%20style&width=1600&height=800&seq=about-hero-bg&orientation=landscape"
            alt="关于韩漫网"
            title="韩漫网品牌故事"
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/45" />

          <div className="relative z-10 w-full flex flex-col items-center text-center px-4">
            <h1 className="font-heading text-3xl md:text-5xl font-bold text-background-50 mb-3">
              关于韩漫网
            </h1>
            <p className="text-lg text-background-50/70 max-w-lg">
              免费韩漫大全 · 让每个人都能享受漫画的乐趣
            </p>
          </div>
        </section>

        <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6 py-6">
          <Breadcrumb
            items={[
              { label: '首页', href: '/' },
              { label: '关于我们' },
            ]}
          />
        </div>

        {/* Brand Story */}
        <section className="py-14 md:py-20 bg-background-50">
          <div className="w-full max-w-[960px] mx-auto px-4 md:px-6">
            <span className="inline-block text-xs font-medium text-accent-600 bg-accent-100/60 px-3 py-1 rounded-full mb-6">
              品牌故事
            </span>

            <h2 className="font-heading text-3xl md:text-5xl font-light text-foreground-900 leading-tight mb-4">
              我们相信每个人都应该
            </h2>
            <h2 className="font-heading text-3xl md:text-5xl font-light text-foreground-900 leading-tight mb-4">
              自由地享受漫画的<span className="text-primary-500 font-semibold">乐趣</span>
            </h2>
            <h2 className="font-heading text-3xl md:text-5xl font-light text-foreground-900 leading-tight mb-16">
              无论身处<span className="text-accent-500 font-semibold">何地</span>
            </h2>

            <div className="flex flex-col sm:flex-row gap-4 mb-16">
              <Link
                to="/category/rexue"
                className="inline-flex items-center justify-center px-8 py-3.5 bg-primary-500 text-background-50 font-medium text-sm rounded-full hover:bg-primary-600 transition-all cursor-pointer whitespace-nowrap"
              >
                开始阅读
              </Link>
              <Link
                to="#contact"
                className="inline-flex items-center justify-center px-8 py-3.5 border border-primary-400 text-primary-500 font-medium text-sm rounded-full hover:bg-primary-50 transition-all cursor-pointer whitespace-nowrap"
              >
                联系我们
              </Link>
            </div>

            <article className="prose-custom max-w-none">
              <p className="text-base md:text-lg text-foreground-700 leading-relaxed mb-6">
                韩漫网成立于2020年，是一个专注于韩国漫画的在线免费阅读平台。我们的创始团队由一群热爱漫画的年轻人组成，深感优质韩漫内容在国内获取渠道有限，因此立志打造一个让中文读者能够便捷、免费地阅读韩国漫画的平台。
              </p>
              <p className="text-base md:text-lg text-foreground-700 leading-relaxed mb-6">
                经过数年的发展，韩漫网已经成为国内领先的韩国漫画阅读平台之一，收录了数千部优质韩国漫画作品，涵盖热血、恋爱、悬疑、奇幻、校园等多种类型。所有内容均采用下拉式在线阅读技术，让阅读体验更加流畅自然。
              </p>
              <p className="text-base md:text-lg text-foreground-700 leading-relaxed mb-6">
                我们始终坚持"免费、完整、优质"的理念，确保平台上的每一部漫画都是<strong>无删减版本</strong>，让读者能够体验到漫画家最初想要表达的完整故事。同时，我们的下拉式阅读技术让用户在手机和电脑上都能获得丝般顺滑的阅读体验。
              </p>
            </article>
          </div>
        </section>

        {/* CTA Section */}
        <section className="relative w-full min-h-[500px] flex items-center overflow-hidden py-20">
          <img
            src="https://readdy.ai/api/search-image?query=A%20wide%20cinematic%20Korean%20manhwa%20style%20illustration%20with%20warm%20atmospheric%20lighting%2C%20abstract%20comic%20pages%20floating%2C%20reading%20nook%20with%20cozy%20lighting%2C%20golden%20and%20coral%20color%20palette%2C%20dreamy%20atmosphere%2C%20digital%20art%20style%2C%20soft%20gradient&width=1600&height=800&seq=about-cta-bg&orientation=landscape"
            alt="加入韩漫网社区"
            title="韩漫网 - 免费韩漫大全"
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-black/50" />

          <div className="relative z-10 w-full max-w-[1280px] mx-auto px-4 md:px-6">
            <div className="flex flex-col items-start gap-8">
              <h3 className="text-5xl md:text-7xl font-bold text-background-50 font-heading leading-none max-w-xl">
                加入我们
              </h3>

              <p className="text-lg md:text-xl text-background-50/80 max-w-md leading-relaxed ml-auto mr-0 md:mr-16">
                成为韩漫网社区的一员，<br />
                与千万漫友一起追更
              </p>

              <Link
                to="#contact"
                className="inline-flex items-center gap-3 px-6 py-3 bg-background-50 text-foreground-900 font-medium text-sm rounded-full hover:bg-background-100 transition-all cursor-pointer group whitespace-nowrap"
              >
                联系我们
                <span className="w-8 h-8 rounded-full bg-foreground-900 flex items-center justify-center group-hover:bg-primary-500 transition-colors">
                  <i className="ri-arrow-right-line text-background-50 text-sm w-4 h-4 flex items-center justify-center" />
                </span>
              </Link>
            </div>
          </div>
        </section>

        {/* Testimonials */}
        <section className="py-14 md:py-20 bg-background-50">
          <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-2">
              用户<span className="text-primary-500">口碑</span>
            </h2>
            <p className="text-sm text-foreground-500 mb-10">来自漫画爱好者们的真实评价</p>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
              {testimonials.map((t, i) => (
                <div
                  key={i}
                  className="bg-background-100 rounded-xl p-5 md:p-6 border border-background-200/70"
                >
                  <div className="flex items-center gap-1 mb-4">
                    {Array.from({ length: t.rating }, (_, j) => (
                      <i key={j} className="ri-star-fill text-accent-500 text-sm w-4 h-4 flex items-center justify-center" />
                    ))}
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                    {t.comment}
                  </p>
                  <p className="text-xs font-semibold text-foreground-900">
                    - {t.name}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* FAQ */}
        <section className="py-14 md:py-20 bg-background-100">
          <div className="w-full max-w-[960px] mx-auto px-4 md:px-6">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-2">
              常见<span className="text-primary-500">问题</span>
            </h2>
            <p className="text-sm text-foreground-500 mb-10">关于韩漫网，你想知道的都在这里</p>

            <div className="flex flex-col gap-3">
              {faqs.map((faq, i) => (
                <details key={i} className="group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden">
                  <summary className="flex items-center justify-between px-5 py-4 cursor-pointer hover:bg-background-100 transition-colors list-none">
                    <h4 className="text-sm font-semibold text-foreground-900 pr-4">
                      <a href={`#faq-${i}`} id={`faq-${i}`}>{faq.question}</a>
                    </h4>
                    <span className="flex-shrink-0 w-5 h-5 flex items-center justify-center group-open:rotate-180 transition-transform">
                      <i className="ri-arrow-down-s-line text-foreground-500 w-4 h-4 flex items-center justify-center" />
                    </span>
                  </summary>
                  <div className="px-5 pb-5">
                    <p className="text-sm text-foreground-600 leading-relaxed">{faq.answer}</p>
                  </div>
                </details>
              ))}
            </div>
          </div>
        </section>

        {/* Contact */}
        <section id="contact" className="py-14 md:py-20 bg-background-50">
          <div className="w-full max-w-[640px] mx-auto px-4 md:px-6">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-2">
              <span className="text-primary-500">联系</span>我们
            </h2>
            <p className="text-sm text-foreground-500 mb-8">有任何问题或建议，欢迎联系我们</p>

            <div className="flex flex-wrap gap-6 mb-10">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-xl bg-accent-100 flex items-center justify-center">
                  <i className="ri-mail-line text-accent-600 w-5 h-5 flex items-center justify-center" />
                </div>
                <div>
                  <p className="text-xs text-foreground-500">邮箱</p>
                  <p className="text-sm font-medium text-foreground-900">hello@stgoldcoast.com</p>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-xl bg-secondary-100 flex items-center justify-center">
                  <i className="ri-wechat-line text-secondary-600 w-5 h-5 flex items-center justify-center" />
                </div>
                <div>
                  <p className="text-xs text-foreground-500">微信</p>
                  <p className="text-sm font-medium text-foreground-900">韩漫网官方</p>
                </div>
              </div>
            </div>

            <form
             
              action="http://stgoldcoast.com/"
              method="POST"
              onSubmit={async (e) => {
                e.preventDefault();
                const form = e.currentTarget;
                const formData = new FormData(form);
                const honeypot = formData.get('website_alt');
                if (honeypot && String(honeypot).trim() !== '') {
                  form.reset();
                  alert('消息已发送！我们会尽快回复您。');
                  return;
                }
                formData.delete('website_alt');
                try {
                  const res = await fetch(form.action, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
                  });
                  const responseText = await res.text();
                  let parsed: any = {};
                  try { parsed = JSON.parse(responseText); } catch (_e) { /* ignore parse error */ }
                  if (res.ok && parsed?.code === 'OK') {
                    form.reset();
                    alert('消息已发送！我们会尽快回复您。');
                  } else {
                    const serverMsg = parsed?.meta?.message || parsed?.message || responseText || '发送失败，请稍后再试';
                    alert(serverMsg);
                  }
                } catch (_err) {
                  alert('网络错误，请稍后再试');
                }
              }}
              className="flex flex-col gap-4"
            >
              <div>
                <label htmlFor="contact-name" className="block text-sm font-medium text-foreground-700 mb-1.5">姓名</label>
                <input
                  type="text"
                  id="contact-name"
                  name="name"
                  required
                  className="w-full px-4 py-3 bg-background-50 border border-background-300 rounded-lg text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors"
                  placeholder="请输入您的姓名"
                />
              </div>
              <div>
                <label htmlFor="contact-email" className="block text-sm font-medium text-foreground-700 mb-1.5">邮箱</label>
                <input
                  type="email"
                  id="contact-email"
                  name="email"
                  required
                  className="w-full px-4 py-3 bg-background-50 border border-background-300 rounded-lg text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors"
                  placeholder="请输入您的邮箱"
                />
              </div>
              <div>
                <label htmlFor="contact-message" className="block text-sm font-medium text-foreground-700 mb-1.5">留言内容</label>
                <textarea
                  id="contact-message"
                  name="message"
                  required
                  rows={5}
                  maxLength={500}
                  className="w-full px-4 py-3 bg-background-50 border border-background-300 rounded-lg text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors resize-none"
                  placeholder="请输入您的留言内容（500字以内）"
                />
              </div>
              <input type="text" name="website_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
              <button
                type="submit"
                className="inline-flex items-center justify-center gap-2 px-8 py-3.5 bg-primary-500 text-background-50 font-medium text-sm rounded-full hover:bg-primary-600 transition-all cursor-pointer whitespace-nowrap"
              >
                发送消息
                <i className="ri-send-plane-line w-4 h-4 flex items-center justify-center" />
              </button>
            </form>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}